import { render } from "./ClientActionsDrawer.vue?vue&type=template&id=9761b4fa&scoped=true"
import script from "./ClientActionsDrawer.vue?vue&type=script&lang=js"
export * from "./ClientActionsDrawer.vue?vue&type=script&lang=js"

import "./ClientActionsDrawer.vue?vue&type=style&index=0&id=9761b4fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9761b4fa"]])

export default __exports__